import { Rect } from '@view-model/models/common/basic/Rect';
import type { ViewerJSON, ClientId } from 'balus-common';
import { Timestamp } from '@framework/Timestamp';

export class Viewer {
  constructor(
    readonly userId: string,
    readonly userName: string,
    readonly imageUrl: string | null,
    readonly isAnonymous: boolean,
    readonly clientId: ClientId,
    readonly rect: Rect,
    readonly timestamp: Timestamp
  ) {}

  dump(): ViewerJSON {
    const { userId, userName, imageUrl, clientId, rect, timestamp, isAnonymous } = this;
    const { position, size } = rect.dump();
    return {
      userId,
      userName,
      imageUrl: imageUrl || null,
      isAnonymous,
      clientId,
      position,
      size,
      timestamp: timestamp.toISOString(),
    };
  }

  static load(dump: ViewerJSON): Viewer {
    const { userId, userName, imageUrl, clientId, position, size, timestamp, isAnonymous } = dump;
    return new this(
      userId,
      userName,
      imageUrl,
      isAnonymous,
      clientId,
      new Rect(position, size),
      new Timestamp(timestamp)
    );
  }

  static compareByTimestamp(a: Viewer, b: Viewer): number {
    return a.timestamp.compareTo(b.timestamp);
  }

  static compareByClientId(a: Viewer, b: Viewer): number {
    return a.clientId.localeCompare(b.clientId);
  }
}
